export function setAll(state, { all }) {
  state.all = all;
}

export function setCurrent(state, { current }) {
  state.current = current;
}
